import { Context } from '@/classes/models'

// initial state
const state = {
  context: null,

  sidenavContextSelectState: {
    isActive: false
  },

  selections: [],
  minimumSelections: []
}

// getters
const getters = {
  /**
   * Is there a valid context selected
   *
   * @return {boolean} true or false
   */
  isContextSelected: state => () => state.context !== null,

  /**
   * Get selection by key
   *
   * @param {string} key
   *
   * @return {object} selection
   */
  getContextSelection: state => key => state.selections[state.selections.findIndex(item => item.key === key)],

  /**
   * Get the context from the selection state, this one isn't applied
   *
   * @returns {Context} context
   */
  getContext: state => () => new Context(state.selections.filter(selection => Boolean(selection.policy)).reduce((context, selection) => { return { ...context, [selection.key]: selection.policy } }, {}))
}

const actions = {
  /**
   * Merge selection object by key
   *
   * @param {string} key
   * @param {string} id
   */
  setSelection: ({ commit, state }, { key, policy }) => {
    const { selections } = state

    if (selections.map(item => item.key).includes(key)) {
      Object.assign(selections[selections.findIndex(item => item.key === key)], { id: policy ? policy.id : undefined, policy })
    } else {
      selections.push({ key, id: policy ? policy.id : undefined, policy })
    }

    commit('setContextProperty', { property: 'selections', value: selections })
  },

  /**
   * Undo an selection
   *
   * @param {string} key
   */
  removeSelection: ({ commit, state }, { key }) => {
    commit('setContextProperty', { property: 'selections', value: state.selections.filter(item => item.key !== key) })
  },

  /**
   * Undo all selections
   */
  removeSelections: ({ commit }) => {
    commit('setContextProperty', { property: 'selections', value: [] })
  },

  /**
   * Reset selection based on minimum of selections
   */
  resetSelection: ({ dispatch, state }) => {
    for (let index = state.selections.length - 1; index >= 0; index--) {
      const selection = state.selections[index]

      if ((index + 1) >= state.minimumSelections.length) {
        dispatch('setSelection', { key: selection.key, policy: null })
      }
    }
  },

  /**
   * Set the minimum of selections
   */
  setMinimumSelections: ({ commit }, selections = []) => {
    commit('setContextProperty', { property: 'minimumSelections', value: selections })
  },

  /**
   * Apply the selection into the current context.
   */
  applySelection: ({ commit, state }) => {
    const context = state.selections.filter(selection => Boolean(selection.policy)).reduce((context, selection) => { return { ...context, [selection.key]: selection.policy } }, {})

    commit('setContextProperty', { property: 'context', value: context })
  },

  /**
   * Clear current context.
   */
  clearAppliedContext: ({ commit }) => {
    commit('setContextProperty', { property: 'context', value: null })
  }
}

// mutations
const mutations = {
  setContextProperty (state, { property, value }) {
    state[property] = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
